import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { Avatar } from "antd";
import { Box } from "@mui/system";
import QRCode from "react-qr-code";
import axios from "axios";
import { toast } from "react-toastify";

// icons
import HowToRegIcon from "@mui/icons-material/HowToReg";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";

// local imports
import ManageAppointmentsIcon from "../../assets/images/icons/Manage_Appointments_Icon.svg";
import CreateLinkIcon from "../../assets/images/icons/Create_Link_Icon.svg";
import BillingIcon from "../../assets/images/icons/Billing.svg";
import UploadReportIcon from "../../assets/images/icons/Upload_Report_Icon.svg";
import QRIcon from "../../assets/images/icons/QRIcon.svg";
import { usePermissions } from "../login/PermissionContext";

const UniversalTile = ({ icon, title, onClick }) => {
  const defaultBg = "#EBFAF9";
  const defaultTextColor = "#121959";
  const hoverBg = "linear-gradient(195.29deg, #64E0D9 10.74%, #114873 95.14%)";

  return (
    <Grid
      item
      xs={12}
      sm={4}
      md={3}
      lg={3}
      sx={{
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "2px",
      }}
    >
      <Box
        onClick={onClick}
        sx={{
          width: "100%",
          maxWidth: { xs: 150, sm: 180, md: 210, lg: 240 },
          aspectRatio: "1 / 1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          borderRadius: "12px",
          transition: "all 0.3s ease",
          position: "relative",
          overflow: "hidden",
          padding: "16px",
          backgroundColor: defaultBg,
          color: defaultTextColor,
          border: "1px solid #21cdc0",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          "&:hover": {
            background: hoverBg,
            color: "#FFFFFF",
            transform: "translateY(-4px)",
            boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.25)",
            "& .tile-arrow": {
              color: "#FFFFFF",
            },
            "& .MuiTypography-root": {
              color: "#FFFFFF !important",
            },
            "& .MuiSvgIcon-root": {
              color: "#FFFFFF !important",
            },
          },
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            marginBottom: "auto",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            marginTop: "8px",
          }}
        >
          {typeof icon === "string" ? (
            <Box
              component="img"
              src={icon}
              alt="icon"
              sx={{
                width: { xs: 45, sm: 60, md: 68, lg: 75 },
                height: { xs: 45, sm: 60, md: 68, lg: 75 },
                color: "inherit",
              }}
            />
          ) : (
            React.cloneElement(icon, {
              sx: {
                fontSize: { xs: 45, sm: 60, md: 68, lg: 75 },
                color: "inherit",
              },
            })
          )}
        </Box>

        {/* Title + Arrow */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "8px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              textAlign: "left",
              fontWeight: "600",
              fontSize: { xs: "16px", sm: "18px", md: "20px" },
              lineHeight: "1.2",
              marginBottom: "32px",
              color: "inherit",
              whiteSpace: "pre-line",
            }}
          >
            {title.replace(" ", "\n")}
          </Typography>

          <Box
            className="tile-arrow"
            sx={{
              marginLeft: "8px",
              color: defaultTextColor,
              transition: "color 0.3s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

const arr = [
  {
    id: "manage patients",
    name: "Patient Management",
    path: "register_patient",
    icon: "/assets/images/newIcons/PM.svg",
  },
  {
    id: "view qr",
    name: "QR Registration",
    path: "scan_qr",
    icon: "/assets/images/newIcons/QR.svg",
  },
  {
    id: "manage appointments",
    name: "Appointment Management",
    path: "doctor/appointments",
    icon: "/assets/images/newIcons/AM.svg",
  },

  {
    id: "create and link visit purpose",
    name: "Create & Link Visit Purpose",
    path: "care_context",
    icon: "/assets/images/newIcons/Clvp.svg",
  },
  {
    id: "upload reports",
    name: "Upload Report",
    path: "upload_report",
    icon: "/assets/images/newIcons/UHR.svg",
  },
  {
    id: "manage billing and invoice",
    name: "Billing and Invoice",
    path: "doctor/item",
    icon: "/assets/images/newIcons/B.svg",
  },
  {
    id: "scan and share records",
    name: "Scan & Share Records",
    path: "scan_share_records",
    icon: "/assets/images/newIcons/SSR.svg",
  },
  {
    id: "manage facilities",
    name: "Facility Management",
    path: "facility_details",
    icon: "/assets/images/newIcons/FM.svg",
  },
  {
    id: "manage users",
    name: "User Management",
    path: "user_details",
    icon: "/assets/images/newIcons/UM.svg",
  },
  {
    id: "manage doctors",
    name: "Doctor Management",
    path: "facility_doctors",
    icon: "/assets/images/newIcons/DM.svg",
  },
  {
    id: "manage billing and transaction",
    name: "Billing and Transaction",
    path: "transaction_records",
    icon: "/assets/images/newIcons/BAT.svg",
  },
  {
    id: "manage_branding",
    name: "Branding Management",
    path: "manage_branding",
    icon: <BrandingWatermarkIcon />,
  },
  {
    id: "manage departments",
    name: "Department Management",
    path: "DepartmentManipulation",
    icon: "/assets/images/newIcons/DEPM.svg",
  },
  {
    id: "manage lab service",
    name: "Lab Service Management",
    path: "laboratories",
    icon: "/assets/images/newIcons/LSM.svg",
  },
  {
    id: "manage medicines",
    name: "Medicines Management",
    path: "pharmacy-user",
    icon: "/assets/images/newIcons/MM.svg",
  },
  {
    id: "manage doctors",
    name: "Schedule Management",
    path: "schedule-management",
    icon: "/Icons/AppointmentScheduleIcon.svg",
  },
  {
    id: "reports",
    name: "Reports & Analytics",
    path: "reports",
    icon: "/assets/images/newIcons/RAA.svg",
  },
  {
    id: "manage patients",
    name: "Patient Historical Records",
    path: "patient-local-data",
    icon: "/assets/images/newIcons/RAA.svg",
  },
];

const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, "_");

export default function MainLandingEntry({ setBrandingData }) {
  const history = useHistory();
  const [title, setTitle] = useState("");
  const [isAbdmEnabled, setIsAbdmEnabled] = useState();
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const { permissions, loading, userInfo } = usePermissions();
  const [dataLoaded, setDataLoaded] = useState(false);

  const navigate = (route) => {
    console.log(route);
    history.push(`/${route}`);
  };
  const [roleType, setRoleType] = useState(
    sessionStorage.getItem("roleType") || ""
  );

  const fetchBrandingData = () => {
    if (
      userInfo?.role_permission?.[0]?.role !== "super admin" &&
      !loading &&
      userInfo
    ) {
      const payload = {
        bucket_type: "license",
        bucket_category: "conf",
        file_key: "",
        facility: false,
      };

      axios
        .post(`${REACT_APP_BACKEND_ROUTE_URL}get_facility_branding/`, payload, {
          headers,
        })
        .then((res) => {
          if (res.data.status === "Success") {
            setBrandingData(res.data?.data);
            console.log("branding..demo", res.data?.data);
          } else if (res?.data?.message === "No files found.") {
            toast.info("Branding information not yet provided");
          } else {
            console.log("Error:", res.data.message);
          }
        })
        .catch((err) => {
          console.log("Error fetching branding data:", err);
          toast.error("Error fetching branding data");
        });
    } else {
      console.log("logged in as superadmin");
    }
  };

  useEffect(() => {
    fetchBrandingData();
  }, [userInfo, loading]);

  const [filteredItems, setFilteredItems] = useState([]);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  console.log("permissions", permissions);

  useEffect(() => {
    if (
      userInfo?.role_permission?.[0]?.role !== "super admin" &&
      authToken !== undefined &&
      authToken.length > 0 &&
      !loading &&
      userInfo
    ) {
      setIsAbdmEnabled(userInfo.abdm_enabled);
      setTitle(userInfo.facility_name);

      const {
        facility_address_line_1,
        facility_address_line_2,
        facility_address_line_3,
        abdm_enabled,
        email_enabled,
        ai_enabled,
        facility_name,
        subscription_type,
        doctor_id,
        facility_id,
      } = userInfo;

      const addressLines = {
        facilityAddressLine1: facility_address_line_1,
        facilityAddressLine2: facility_address_line_2,
        facilityAddressLine3: facility_address_line_3,
      };

      Object.entries(addressLines).forEach(([key, value]) =>
        sessionStorage.setItem(key, value ?? "")
      );

      sessionStorage.setItem("isAbdmEnabled", abdm_enabled);
      sessionStorage.setItem("isEmailEnabled", email_enabled);
      sessionStorage.setItem("isAiEnabled", ai_enabled);
      sessionStorage.setItem("facility_display_name", facility_name);
      sessionStorage.setItem("subscription_type", subscription_type);
      sessionStorage.setItem("facility_name", facility_id);
      if (doctor_id) {
        sessionStorage.setItem("doctor_id", doctor_id);
      }
      setDataLoaded(true);
    }
  }, [authToken, userInfo, loading]);

  console.log("testing...", userInfo);
  const abdmRestrictedIds = new Set([
    // "upload reports",
    // "view qr",
    "scan and share records",
  ]);

  const removeAiRestrictedTiles = (items) => {
    if (userInfo?.abdm_enabled) {
      return items;
    }
    return items.filter((item) => !abdmRestrictedIds.has(item.id));
  };

  useEffect(() => {
    if (
      userInfo?.role_permission?.[0]?.role === "super admin" &&
      !loading &&
      userInfo
    ) {
      const allowedForAdmin = [
        "manage facilities",
        "manage users",
        "manage doctors",
      ];
      const items = arr.filter((item) => allowedForAdmin.includes(item.id));
      setFilteredItems(removeAiRestrictedTiles(items));
    } else if (permissions && permissions.length > 0) {
      const allowedIds = new Set(
        permissions
          .filter((p) => p.is_accessible)
          .map((p) => normalize(p.permission_name))
      );

      const items = arr.filter((item) => allowedIds.has(normalize(item.id)));
      setFilteredItems(removeAiRestrictedTiles(items));
    } else {
      setFilteredItems([]);
    }
  }, [permissions, userInfo, loading]);

  if (loading) {
    return <Typography textAlign="center">Loading...</Typography>;
  }

  return (
    <div>
      {filteredItems.length > 0 ? (
        <Grid
          container
          spacing={2}
          sx={{
            p: { xs: 1, sm: 1, md: 2 },
            py: { xs: 1, sm: 2, md: 3 },
            width: "100%",
            maxWidth: "1100px",
            justifyContent: "center",
            // backgroundColor: "white",
            // borderRadius: "16px",
            // boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
            margin: "auto",
          }}
        >
          {filteredItems.map((item, index) => (
            <UniversalTile
              key={item.id}
              icon={item.icon}
              title={item.name}
              onClick={() => navigate(item.path)}
              isFirstTile={index === 0}
            />
          ))}
        </Grid>
      ) : (
        <Typography variant="h3" textAlign="center">
          No Entitlement
        </Typography>
      )}
    </div>
  );
}
